import React, { Component } from 'react';
import firebase from '../../store/firebase';

class LatestMEVerrEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latestEntry: null,
      entryKey: null,
      loading: true,
      error: null,
    };
    this.dbRef = null;
  }

  componentDidMount() {
    this.dbRef = firebase
      .database
      .ref('MEVerr')
      .orderByChild('errDate')
      .limitToLast(1);

    this.dbRef.on(
      'value',
      (snapshot) => {
        if (snapshot.exists()) {
          let entryKey = null;
          let latestEntry = null;

          snapshot.forEach((childSnapshot) => {
            entryKey = childSnapshot.key;
            latestEntry = childSnapshot.val();
          });

          this.setState({
            latestEntry,
            entryKey,
            loading: false,
            error: null,
          });
        } else {
          this.setState({
            latestEntry: null,
            entryKey: null,
            loading: false,
            error: null,
          });
        }
      },
      (error) => {
        console.error('Firebase Realtime DB error:', error);
        this.setState({
          loading: false,
          error: error.message,
        });
      }
    );
  }

  componentWillUnmount() {
    if (this.dbRef) {
      this.dbRef.off();
    }
  }

  render() {
    const { latestEntry, entryKey, loading, error } = this.state;

    if (loading) {
      return (
        <div style={{ padding: '14px', fontFamily: 'Arial, sans-serif' }}>
          <p>Loading latest MEVerr entry from Firebase Realtime Database...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div style={{ padding: '14px', color: 'red', fontFamily: 'Arial, sans-serif' }}>
          <p>Error loading data: {error}</p>
        </div>
      );
    }

    if (!latestEntry) {
      return (
        <div style={{ padding: '14px', fontFamily: 'Arial, sans-serif' }}>
          <p>No entries found in the MEVerr collection.</p>
        </div>
      );
    }

    // Build table rows for every field in the entry
    const tableRows = Object.entries(latestEntry).map(([field, value]) => (
      <tr key={field}>
        <td
          style={{
            padding: '8px',
            border: '1px solid #ccc',
            fontWeight: 'bold',
            backgroundColor: '#f9f9f9',
            width: '154px',
            fontSize: '13px',
          }}
        >
          {field}
        </td>
        <td
          style={{
            padding: '8px',
            border: '1px solid #ccc',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontSize: '13px',
          }}
        >
          {typeof value === 'boolean'
            ? value
              ? 'true'
              : 'false'
            : value === null || value === undefined
            ? 'null'
            : String(value)}
        </td>
      </tr>
    ));

    return (
      <div
        style={{
          padding: '14px',
          fontFamily: 'Arial, sans-serif',
          maxWidth: '630px',
          fontSize: '13px', // text is now a little larger while keeping the compact table size
        }}
      >
        <h2 style={{ fontSize: '1.65rem', marginBottom: '11px' }}>
          Last Error on MEV Exchange
        </h2>
        <p style={{ marginBottom: '11px' }}>
          <strong>Firebase Key:</strong> {entryKey}
        </p>

        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  padding: '8px',
                  border: '1px solid #ccc',
                  backgroundColor: '#f1f1f1',
                  textAlign: 'left',
                  fontSize: '13px',
                }}
              >
                Field
              </th>
              <th
                style={{
                  padding: '8px',
                  border: '1px solid #ccc',
                  backgroundColor: '#f1f1f1',
                  textAlign: 'left',
                  fontSize: '13px',
                }}
              >
                Value
              </th>
            </tr>
          </thead>
          <tbody>{tableRows}</tbody>
        </table>

        <p
          style={{
            marginTop: '11px',
            fontSize: '0.85em',
            color: '#666',
          }}
        >
          This component listens in realtime. Refreshing the page or adding a newer entry in Firebase will automatically update the table.
        </p>
      </div>
    );
  }
}

export default LatestMEVerrEntry;
///////////////////////////////////////////////////////////////////////////////////////
// import React, { Component } from 'react';
// import firebase from '../../store/firebase';

// class LatestMEVerrEntry extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       latestEntry: null,
//       entryKey: null,
//       loading: true,
//       error: null,
//     };
//     this.dbRef = null;
//   }

//   componentDidMount() {
//     this.dbRef = firebase
//       .database
//       .ref('MEVerr')
//       .orderByChild('errDate')
//       .limitToLast(1);

//     this.dbRef.on(
//       'value',
//       (snapshot) => {
//         if (snapshot.exists()) {
//           let entryKey = null;
//           let latestEntry = null;

//           snapshot.forEach((childSnapshot) => {
//             entryKey = childSnapshot.key;
//             latestEntry = childSnapshot.val();
//           });

//           this.setState({
//             latestEntry,
//             entryKey,
//             loading: false,
//             error: null,
//           });
//         } else {
//           this.setState({
//             latestEntry: null,
//             entryKey: null,
//             loading: false,
//             error: null,
//           });
//         }
//       },
//       (error) => {
//         console.error('Firebase Realtime DB error:', error);
//         this.setState({
//           loading: false,
//           error: error.message,
//         });
//       }
//     );
//   }

//   componentWillUnmount() {
//     if (this.dbRef) {
//       this.dbRef.off();
//     }
//   }

//   render() {
//     const { latestEntry, entryKey, loading, error } = this.state;

//     if (loading) {
//       return (
//         <div style={{ padding: '14px', fontFamily: 'Arial, sans-serif' }}>
//           <p>Loading latest MEVerr entry from Firebase Realtime Database...</p>
//         </div>
//       );
//     }

//     if (error) {
//       return (
//         <div style={{ padding: '14px', color: 'red', fontFamily: 'Arial, sans-serif' }}>
//           <p>Error loading data: {error}</p>
//         </div>
//       );
//     }

//     if (!latestEntry) {
//       return (
//         <div style={{ padding: '14px', fontFamily: 'Arial, sans-serif' }}>
//           <p>No entries found in the MEVerr collection.</p>
//         </div>
//       );
//     }

//     // Build table rows for every field in the entry
//     const tableRows = Object.entries(latestEntry).map(([field, value]) => (
//       <tr key={field}>
//         <td
//           style={{
//             padding: '8px',
//             border: '1px solid #ccc',
//             fontWeight: 'bold',
//             backgroundColor: '#f9f9f9',
//             width: '154px',
//             fontSize: '11px',
//           }}
//         >
//           {field}
//         </td>
//         <td
//           style={{
//             padding: '8px',
//             border: '1px solid #ccc',
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-word',
//             fontSize: '11px',
//           }}
//         >
//           {typeof value === 'boolean'
//             ? value
//               ? 'true'
//               : 'false'
//             : value === null || value === undefined
//             ? 'null'
//             : String(value)}
//         </td>
//       </tr>
//     ));

//     return (
//       <div
//         style={{
//           padding: '14px',
//           fontFamily: 'Arial, sans-serif',
//           maxWidth: '630px',
//           fontSize: '11px', // overall 30% smaller fonts
//         }}
//       >
//         <h2 style={{ fontSize: '1.4rem', marginBottom: '11px' }}>
//           Latest MEVerr Entry (most recent by errDate)
//         </h2>
//         <p style={{ marginBottom: '11px' }}>
//           <strong>Firebase Key:</strong> {entryKey}
//         </p>

//         <table
//           style={{
//             width: '100%',
//             borderCollapse: 'collapse',
//             boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//           }}
//         >
//           <thead>
//             <tr>
//               <th
//                 style={{
//                   padding: '8px',
//                   border: '1px solid #ccc',
//                   backgroundColor: '#f1f1f1',
//                   textAlign: 'left',
//                   fontSize: '11px',
//                 }}
//               >
//                 Field
//               </th>
//               <th
//                 style={{
//                   padding: '8px',
//                   border: '1px solid #ccc',
//                   backgroundColor: '#f1f1f1',
//                   textAlign: 'left',
//                   fontSize: '11px',
//                 }}
//               >
//                 Value
//               </th>
//             </tr>
//           </thead>
//           <tbody>{tableRows}</tbody>
//         </table>

//         <p
//           style={{
//             marginTop: '11px',
//             fontSize: '0.63em',
//             color: '#666',
//           }}
//         >
//           This component listens in realtime. Refreshing the page or adding a newer entry in Firebase will automatically update the table.
//         </p>
//       </div>
//     );
//   }
// }

// export default LatestMEVerrEntry;
///////////////////////////////////////////////////////////////////////////////////
// import React, { Component } from 'react';
// import firebase from '../../store/firebase';

// class LatestMEVerrEntry extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       latestEntry: null,
//       entryKey: null,
//       loading: true,
//       error: null,
//     };
//     this.dbRef = null;
//   }

//   componentDidMount() {
//     // Query the MEVerr collection: sort by errDate (string format "YYYY-MM-DD HH:MM" is lexicographically sortable)
//     // and take only the last (newest) entry
//     this.dbRef = firebase
//       .database
//       .ref('MEVerr')
//       .orderByChild('errDate')
//       .limitToLast(1);

//     this.dbRef.on(
//       'value',
//       (snapshot) => {
//         if (snapshot.exists()) {
//           let entryKey = null;
//           let latestEntry = null;

//           // Since we used limitToLast(1), there will be only one child
//           snapshot.forEach((childSnapshot) => {
//             entryKey = childSnapshot.key;
//             latestEntry = childSnapshot.val();
//           });

//           this.setState({
//             latestEntry,
//             entryKey,
//             loading: false,
//             error: null,
//           });
//         } else {
//           this.setState({
//             latestEntry: null,
//             entryKey: null,
//             loading: false,
//             error: null,
//           });
//         }
//       },
//       (error) => {
//         console.error('Firebase Realtime DB error:', error);
//         this.setState({
//           loading: false,
//           error: error.message,
//         });
//       }
//     );
//   }

//   componentWillUnmount() {
//     // Clean up the realtime listener to prevent memory leaks
//     if (this.dbRef) {
//       this.dbRef.off();
//     }
//   }

//   render() {
//     const { latestEntry, entryKey, loading, error } = this.state;

//     if (loading) {
//       return (
//         <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
//           <p>Latest MEV Exchange</p>
//         </div>
//       );
//     }

//     if (error) {
//       return (
//         <div style={{ padding: '20px', color: 'red', fontFamily: 'Arial, sans-serif' }}>
//           <p>Error loading data: {error}</p>
//         </div>
//       );
//     }

//     if (!latestEntry) {
//       return (
//         <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
//           <p>No entries found in the MEVerr collection.</p>
//         </div>
//       );
//     }

//     // Build table rows for every field in the entry
//     const tableRows = Object.entries(latestEntry).map(([field, value]) => (
//       <tr key={field}>
//         <td
//           style={{
//             padding: '12px',
//             border: '1px solid #ccc',
//             fontWeight: 'bold',
//             backgroundColor: '#f9f9f9',
//             width: '220px',
//           }}
//         >
//           {field}
//         </td>
//         <td
//           style={{
//             padding: '12px',
//             border: '1px solid #ccc',
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-word',
//           }}
//         >
//           {typeof value === 'boolean'
//             ? value
//               ? 'true'
//               : 'false'
//             : value === null || value === undefined
//             ? 'null'
//             : String(value)}
//         </td>
//       </tr>
//     ));

//     return (
//       <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '900px' }}>
//         <h2>Latest MEVerr Entry (most recent by errDate)</h2>
//         <p style={{ marginBottom: '15px' }}>
//           <strong>Firebase Key:</strong> {entryKey}
//         </p>

//         <table
//           style={{
//             width: '100%',
//             borderCollapse: 'collapse',
//             boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//           }}
//         >
//           <thead>
//             <tr>
//               <th
//                 style={{
//                   padding: '12px',
//                   border: '1px solid #ccc',
//                   backgroundColor: '#f1f1f1',
//                   textAlign: 'left',
//                   fontSize: '16px',
//                 }}
//               >
//                 Field
//               </th>
//               <th
//                 style={{
//                   padding: '12px',
//                   border: '1px solid #ccc',
//                   backgroundColor: '#f1f1f1',
//                   textAlign: 'left',
//                   fontSize: '16px',
//                 }}
//               >
//                 Value
//               </th>
//             </tr>
//           </thead>
//           <tbody>{tableRows}</tbody>
//         </table>

//         <p style={{ marginTop: '15px', fontSize: '0.9em', color: '#666' }}>
//           This component listens in realtime. Refreshing the page or adding a newer entry in Firebase will automatically update the table.
//         </p>
//       </div>
//     );
//   }
// }

// export default LatestMEVerrEntry;